// import * as amplitude from '@amplitude/analytics-browser';

// import { Injectable } from '@angular/core';
// import { environment } from '../../../environments/environment';

// @Injectable({
//   providedIn: 'root',
// })
// export class AmplitudeService {
//   constructor() {}

//   initAmplitude() {
//     amplitude.init(environment.ampKey);
//   }

//   trackEvent(eventName: string, isKeyAction = false, eventProperties?: any) {
//     const eventData = {
//       isKeyAction,
//       ...eventProperties,
//     };

//     eventData.path = window.location.pathname;
//     amplitude.track(eventName, eventData);
//   }
// }

import * as amplitude from '@amplitude/analytics-browser';
import { Injectable, inject } from '@angular/core';
import { ENVIRONMENT } from '../../../environments/environment.type';

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  private environment = inject(ENVIRONMENT);

  initAmplitude() {
    amplitude.init(this.environment.ampKey);
  }

  trackEvent(eventName: string, _isKeyAction = false, eventProperties?: Record<string, any>) {
    const eventData = {
      ...eventProperties,
      Path: window.location.pathname,
    };

    amplitude.track(eventName, eventData);
  }
}
